// ─────────────────────────────────────────────────────────────
// Feature Tours Configuration
// ─────────────────────────────────────────────────────────────
// To add a new feature tour, just add a new object to the TOURS array.
// The system will automatically handle:
//   - Guided spotlight tour (highlights UI elements step by step)
//   - Dashboard promotional banner
//   - "New!" badges on specified elements
//   - localStorage-based dismiss/seen tracking
//
// Example:
//   { id: 'my-feature', page: 'game-editor', active: true, steps: [...], banner: {...}, badges: [...] }
// ─────────────────────────────────────────────────────────────

export interface TourStep {
  selector: string
  title: string
  description: string
  side?: 'top' | 'bottom' | 'left' | 'right'
}

export interface TourBadge {
  selector: string
  text: string
  color?: string
}

export interface FeatureTour {
  id: string
  page: string
  active: boolean
  steps: TourStep[]
  badges?: TourBadge[]
  priority?: number
}

export const TOURS: FeatureTour[] = [
  {
    id: 'ai-features',
    page: 'game-editor',
    active: true,
    priority: 1,
    steps: [
      {
        selector: '.ai-generate-btn',
        title: 'tour.ai.step1Title',
        description: 'tour.ai.step1Desc',
        side: 'right',
      },
      {
        selector: '.ai-edit-btn',
        title: 'tour.ai.step2Title',
        description: 'tour.ai.step2Desc',
        side: 'left',
      },
      {
        selector: '.border-style',
        title: 'tour.ai.step3Title',
        description: 'tour.ai.step3Desc',
        side: 'left',
      },
      {
        selector: '.credits-col',
        title: 'tour.ai.step4Title',
        description: 'tour.ai.step4Desc',
        side: 'bottom',
      },
    ],
    badges: [
      {
        selector: '.ai-generate-btn',
        text: 'tour.ai.badgeNew',
        color: 'error',
      },
      {
        selector: '.ai-btn',
        text: 'tour.ai.badgeNew',
        color: 'error',
      },
    ],
  },
]
